import Cookies from "js-cookie";

export const useToken = () => {
    if (typeof window !== 'undefined') {
        const tokenKey = import.meta.env.VITE_TOKEN_NAME || "token";

        const localToken = localStorage.getItem(tokenKey);
        if (localToken) return localToken;

        const cookieToken = Cookies.get(tokenKey);
        if (cookieToken) return cookieToken;
    }

    return null;
};